const FormConfig = {

	selectors: {
		infiltrationType: '.infiltrationType',
		rigoleOnly: '.rigoleOnly',
		retentionOnly: '.retentionOnly',
		rainwaterUtilisationOnly: '.rainwaterUtilisationOnly',
		country: '.country',
		weatherStation: '#weatherStation',

		configurationForm: '#configurationForm',
		rcIndexInput: '#rcIndexValue',
		rcIndexOutput: '#currentRcIndex',
		originalGridIndexInput: '#originalGridIndexValue',
		regionInput: '#regionValue',
		customRunoffValueInput: '#customRunoffValue',
		customRunoffValueIndexNotation: '#customRunoffValueIndexNotation',
		customRunoffValueSignificand: '#customRunoffValueSignificand',
		customRunoffValueExponent: '#customRunoffValueExponent',
		runoffValueIndexNotationResult: '#runoffValueIndexNotationResult',
		addAreaTypeButton: '#addAreaType',
		addAreaTypeLimitReached: '#addAreaTypeLimitReached',
		removeAreaTypeButton: '.removeAreaType',
		areaTypeBlock: '.areaTypeBlock',
		areaTypeSelect: '.roofType',
		runofftypeSelect: '.runoffType',
		runofftypeValue: '.runoffTypeValue',
		coefficientSelect: '.coefficient',
		coefficientValue: '.coefficientValue',
		areaInput: '.area',
		cityInput: '#city',
		citySelect: '#citySelect',
		resilienceRadio: '.resilienceRadio',
		productCheckbox: '.productCheckbox',
		assignedTeamSelect: '#assignedTeam',
		processorSelect: '#processor',
		weatherStationCheckLoading: '#weatherStationCheckLoading',
		rainwaterMapLoading: '#rainwaterMapLoading',
		weatherStationCheckResult: '#weatherStationCheckResult',
		weatherstationMapResult: '#weatherstationMapResult',
		manualWeatherStationSelection: '.manualWeatherStationSelection',
		propertyStreetInput: '#street',
		propertyZipInput: '#propertyZip',
		propertyCityInput: '#propertyCity',
		propertyCityDisplay: '#propertyCityDisplay',
		configurationSubmit: '#configurationSubmit',
		groundReportInfoStep1: '#groundReportInfoStep1',
		groundReportInfoStep2: '#groundReportInfoStep2',
		activateGroundReportFilesUploadButton: '#activateGroundReportFilesUpload',
		confirmGroundReportFilesUpload: '#confirmGroundReportFilesUpload',
		cancelGroundReportFilesUpload: '.cancelGroundReportFilesUpload',
		groundReportFilesUploadHidden: '#groundReportFilesUpload',
		soilTypeSelectionContainer: '#soilTypeSelection',
		groundReportFilesUploadNotification: '#groundReportFilesUploadNotification',
		clientTypeSelect: '#clientTypes',
		companyInput: '#clientCompany',
		changeWeatherStation: '#changeWeatherStation',
		weatherStationZip: '#weatherStationZip',
		confirmManualWeatherStationSelection: '#confirmManualWeatherStationSelection',
		grafPartnerRow: '.row.graf-partner',
		grafPartnerCheckbox: '#hasGrafPartner',
		grafPartnerInput: '#clientGrafPartner > input',
		attenuationPlusRow: '.row.attenuationPlus',
		attenuationPlusCheckbox: 'input.attenuationPlusCheckbox',
		permittedDischargeInput: '#permittedDischarge',
		permittedDischargeUnitInput: '#permittedDischargeUnit',
		rainDrainageInput: '#rainDrainage',
		rainDrainageAreaInput: '#area',
		permittedDischargeError: '#permittedDischargeError',
		ignorePermittedDischargeCheckbox: '#ignorePermittedDischarge',
		rainFrequencySelect: '#rainFrequency',
	},

	values: {
		infiltrationType: {
			RIGOLE: 1,
			TROUGH_RIGOLE: 2,
			RETENTION_CISTERN: 3
		},
		customerTypes: {
			END_CUSTOMER: 1,
			PROCESSORS: 2
		},
		countries: {
			GERMANY: 1,
			AUSTRIA: 2,
			SWITZERLAND: 3,
			BELGIUM: 4,
			NETHERLANDS: 5,
			LUXEMBOURG: 6
		}
	}
};

export default FormConfig;
